import React, { Component } from 'react';
import moment from 'moment';
import Legend from './Legend';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { vesselDot } from './PointerIcon';
import Control from 'react-leaflet-control';
import MarkerTracking from './MarkerTracking';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Map, TileLayer, LayerGroup, Marker } from 'react-leaflet';

import { 
  Row, Col, Card, CardHeader, CardBody, FormGroup, Button, InputGroup
} from 'reactstrap';

import { vesselTrackingGet, vesselTrackingView, getShipList } from '../../../actions/dashboardAction';

let thisYear = moment().format('Y');
let thisMonth = moment().format('M');

let month_option = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' }
];

class VesselTracking extends Component {

  constructor(props) {
    super(props)
    this.state = {
      viewAll: true,
      month: '',
      year: '',
      kapal_id: '',
    }

    this.markersGroupRef = React.createRef();
    this.layerViewRef = React.createRef();
    this.viewSchedule = this.viewSchedule.bind(this);
    this.viewAllTracking = this.viewAllTracking.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.selectYear = this.selectYear.bind(this);
    this.selectShip = this.selectShip.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  componentDidMount() {
    let data = {
      month: thisMonth,
      year: thisYear,
      kapal_id : "",
    };
    this.props.vesselTrackingGet(data);
    this.props.getShipList({});
  }

  selectMonth(event) {
    this.setState({ month: event.target.value });
  }

  selectShip(event) {
    this.setState({ kapal_id: event.target.value });
  }

  selectYear(event) {
    this.setState({ year: event.target.value });
  }

  handleFilter(event, values) {
    if (this.state.month !== '') {
      values.month = this.state.month;
    } 
    else {
      values.month = thisMonth;
    }

    if (this.state.year !== '') {
      values.year = this.state.year;
    } 
    else {
      values.year = thisYear;
    }

    if (this.state.kapal_id !== '') {
      values.kapal_id = this.state.kapal_id;
    } 
    else {
      values.kapal_id = "";
    }
    this.props.vesselTrackingGet(values)
  }

  viewSchedule(data) {
    this.props.vesselTrackingView({ jadwal_id: data });
    this.markersGroupRef.current.leafletElement.clearLayers();
    this.setState({ viewAll: false });
  }

  viewAllTracking() {
    this.layerViewRef.current.leafletElement.clearLayers();
    this.setState({ viewAll: true });
  }

  renderMarkers() {
    if (this.props.isSuccess) {
      let defaultValues = {
        month: this.state.month,
        year: this.state.year,
        kapal_id: this.state.kapal_id,
      };

      const styleSelect = {
        control: styles => ({ ...styles, minWidth: '200px' })
      };

      return (
        <LayerGroup ref={this.markersGroupRef}>
          {this.props.trackingData.data.map((item, index) => (
            <MarkerTracking data={item} key={index} viewFunction={this.viewSchedule} />
          ))}
          <Control position="topright">
            <Card>
              <CardBody>
                <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                  <Row>
                    <Col md="2">
                      <FormGroup>
                        <AvField type="select" name="year" onChange={this.selectYear}>
                          <option value="">Tahun</option>
                          {this.props.trackingData &&
                            this.props.trackingData.year.map((item, key) => (
                              <option key={key} value={item.year}>{item.year}</option>
                            ))
                          }
                        </AvField>
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <AvField type="select" name="month" onChange={this.selectMonth}>
                          <option value="">Bulan</option>
                          {month_option.map((item, key) => (
                            <option key={key} value={item.value}>{item.label}</option>
                          ))}
                        </AvField>
                      </FormGroup>
                    </Col>
                    {this.props.getShipListSuccess && 
                    <Col md="4">
                      <FormGroup>
                        <AvField type="select" name="kapal_id" onChange={this.selectShip}>
                          <option value="">Kapal</option>
                          {this.props.shipList.map((item, key) => (
                            <option key={key} value={item.id}>{item.label}</option>
                          ))}
                        </AvField>
                      </FormGroup>
                    </Col>
                    }
                    <Col md="3">
                      <FormGroup className="form-actions">
                        <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                          <i className="fa fa-search"></i> <span>Proses</span>
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Control>
        </LayerGroup>
      );
    }
  }

  renderView() {
    if (this.props.viewIsSuccess) {
      return (
        <LayerGroup ref={this.layerViewRef}>
          {this.props.views.data.tracking.map((item, idx, array) => (
            <Marker position={[item.lat, item.lon]} icon={vesselDot} key={idx} />
          ))}
          <Legend backFunction={this.viewAllTracking} data={this.props.views.data} />
        </LayerGroup>
      );
    }
  }

  render() {
    // console.log("PROPS ===>>> ", this.props);
    // console.log("STATE ===>>> ", this.state);

    return (
      <Card>
        <CardHeader>
          <AvForm>
            <Row>
              <Col md="7" sm="6">
                <h5>Vessel Tracking</h5>
              </Col>
            </Row>
          </AvForm>
        </CardHeader>
        <CardBody style={{ padding: 3 }}>
          <Map center={[-2.2297706, 117.9262678]} zoom={5} style={{ height: '500px' }}>
            <TileLayer
              attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {this.state.viewAll ? this.renderMarkers() : this.renderView()}
          </Map>
        </CardBody>
      </Card>
    );
  }

}

VesselTracking.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,

  viewIsSuccess: PropTypes.bool.isRequired,
  viewHasError: PropTypes.bool.isRequired,
  viewIsLoading: PropTypes.bool.isRequired,

  getShipListLoading: PropTypes.bool.isRequired,
  getShipListSuccess: PropTypes.bool.isRequired,
  getShipListError: PropTypes.bool.isRequired,
  shipList: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    trackingData: state.dashboard.vesselTrackingGet,
    isSuccess: state.dashboard.vesselTrackingGetSuccess,
    hasError: state.dashboard.vesselTrackingGetError,
    isLoading: state.dashboard.vesselTrackingGetLoading,

    views: state.dashboard.vesselTrackingView,
    viewIsSuccess: state.dashboard.vesselTrackingViewSuccess,
    viewHasError: state.dashboard.vesselTrackingViewError,
    viewIsLoading: state.dashboard.vesselTrackingViewLoading,

    getShipListLoading: state.dashboard.getShipListLoading,
    getShipListSuccess: state.dashboard.getShipListSuccess,
    getShipListError: state.dashboard.getShipListError,
    shipList: state.dashboard.shipList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    vesselTrackingGet: (data) => dispatch(vesselTrackingGet(data)),
    vesselTrackingView: (data) => dispatch(vesselTrackingView(data)),
    getShipList: (data) => dispatch(getShipList(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VesselTracking);